module.exports = __webpack_public_path__ + "static/img/cwiczenie-80px.fc08de2e.png";